import { Injectable } from '@angular/core';
import { Log } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class HostnameService {
  private static readonly workforceHostnames = ['app.workforce.ai', 'workforce.ai', '127.0.0.1'];

  constructor() {}

  static isWorkforceHostname(): boolean {
    return true;
    const hostname = window.location.hostname;
    Log.d('Checking if hostname is workforce', hostname);

    // TEMP FOR DEVE ONLY!
    if (hostname.includes('workforce')) {
      return true;
    }

    return this.workforceHostnames.includes(hostname);
  }
}
